import { Component, OnInit, ChangeDetectorRef, ViewChild } from "@angular/core";
import { MatSort, MatPaginator, MatTableDataSource } from "@angular/material";
import { ReportsService } from "src/app/services/reports/reports.service";
import { AlertsService } from "src/app/services/shared/alerts.service";
import { ExcelService } from "src/app/services/excel.service";
import { TipoMovimiento } from "src/app/models/enums/tipo-movimiento.enum";
import { TipoEquipo } from "src/app/models/enums/tipo-equipo.enum";

import * as moment from "moment";
declare let $: any;

@Component({
  selector: "ag-comercial-chains",
  templateUrl: "./comercial-chains.component.html",
  styleUrls: ["./comercial-chains.component.scss"],
})
export class ComercialChainsComponent implements OnInit {
  tipoEquipo = TipoEquipo;
  tipoMovimiento = TipoMovimiento;
  commercialChainReport: any[];
  noReg = 10;
  page: number = 1;
  fechaInicio: string = "";
  fechaFin: string = "";
  isLoading = false;
  queried = false;
  isEmpty = true;
  options = {
    format: "yyyy-mm-dd",
    maxDate: new Date(),
    autoClose: true,
    showClearBtn: true,
  };
  constructor(
    private cd: ChangeDetectorRef,
    private reportSrv: ReportsService,
    private alertsService: AlertsService,
    private excSrv: ExcelService
  ) {}

  ngOnInit() {
    this.initComponents();
  }

  changeLast(e) {
    if (!e.target || !e.target.value) return;
    console.log(
      moment(new Date(e.target.value)).add(1, "d").format("YYYY-MM-DD")
    );

    this.fechaFin = moment(new Date(e.target.value))
      .add(1, "d")
      .format("YYYY-MM-DD");
  }

  changeFirst(e) {
    if (!e.target || !e.target.value) return;
    console.log(
      moment(new Date(e.target.value)).add(1, "d").format("YYYY-MM-DD")
    );
    this.fechaInicio = moment(new Date(e.target.value))
      .add(1, "d")
      .format("YYYY-MM-DD");
  }

  initComponents() {
    $("#fechaInicio").datepicker({
      ...this.options,
      onSelect: this.changeFirst,
    });
    $("#fechaFin").datepicker({ ...this.options, onSelect: this.changeLast });
  }

  async searchComercialChains() {
    this.isLoading = true;
    this.queried = true;
    this.commercialChainReport = [];
    try {
      const res: any[] = await this.reportSrv.getComercialChains({
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
      });
      this.commercialChainReport = res;
      this.isEmpty = res.length < 1;
      if (this.isEmpty)
        this.alertsService.warning({
          title: "No existen registros para las fechas Especificadas",
        });
    } catch (err) {
      this.alertsService.error({ text: err });
    } finally {
      this.isLoading = false;
    }
  }

  async downloadExcel() {
    const headers = {
      id: "ID",
      tipo_movimiento: "Tipo de Movimiento",
      determinante: "Determinante",
      promotor_Nombre: "Nombre del promotor",
      promotor_Apellidos: "Apellidos",
      fecha_creacion: "Fecha",
      id_producto: "Tipo de Equipo",
      fecha_actualizacion: "Actualizacion",
      imei: "IMEI",
      iccid: "ICCID",
      numero: "Telefono",
    };
    const dataToExcel = this.commercialChainReport.map((report) => ({
      ...report,
      ["tipo_movimiento"]: this.tipoMovimiento[report.tipo_movimiento],
      ["id_producto"]: this.tipoEquipo[report.tipo_equipo],
      ["imei"]: `'${report.imei}'`,
      ["iccid"]: `'${report.iccid}'`,
    }));
    console.log(dataToExcel);

    await this.excSrv.generateExcel(
      headers,
      dataToExcel,
      "Reporte_cadenas_comerciales"
    );
  }
}
